export const tokens = {
  "color-gray-650": "oklch(20.35% .0139 285.09deg)",
  "color-gray-600": "oklch(25.65% .0265 278.04deg)",
  "color-gray-550": "oklch(29.74% .0362 281.74deg)",
  "color-gray-500": "oklch(33.88% .0354 277.71deg)",
  "color-gray-450": "oklch(37.75% .0361 278.19deg)",
  "color-gray-400": "oklch(48.09% .0371 279.08deg)",
  "color-gray-350": "oklch(56.28% .045 278.7deg)",
  "color-gray-300": "oklch(67.22% .0355 279.77deg)",
  "color-gray-250": "oklch(79.05% .0283 281.19deg)",
  "color-gray-200": "oklch(86.72% .0192 282.72deg)",
  "color-gray-150": "oklch(93.86% .0108 280.47deg)",
  "color-gray-100": "oklch(97.59% .0029 264.54deg)",
  "color-red-500": "oklch(42.24% .1681 30.2666deg)",
  "color-red-450": "oklch(51.46% .2065 29.98deg)",
  "color-red-400": "oklch(55.73% .2161 29.71deg)",
  "color-red-350": "oklch(60.93% .2212 29.33deg)",
  "color-red-300": "oklch(66.71% .2202 28.6deg)",
  "color-red-250": "oklch(73.92% .1589 26.1665deg)",
  "color-red-200": "oklch(84.53% .0845 23.47deg)",
  "color-red-150": "oklch(89.94% .0522 22.54deg)",
  "color-red-100": "oklch(95.79% .0208 21.17deg)",
  "color-orange-500": "oklch(46.68% .1161 51.53deg)",
  "color-orange-450": "oklch(54.6% .1286 56.49deg)",
  "color-orange-400": "oklch(62.76% .1418 61.45deg)",
  "color-orange-350": "oklch(70.46% .1543 66.16deg)",
  "color-orange-300": "oklch(76.62% .166 68.76deg)",
  "color-orange-250": "oklch(81.19% .1424 76.67deg)",
  "color-orange-200": "oklch(87.41% .1102 76.47deg)",
  "color-orange-150": "oklch(92.32% .0692 78.84deg)",
  "color-orange-100": "oklch(97.56% .0244 83.42deg)",
  "color-teal-600": "oklch(26.97% .0428 220.91deg)",
  "color-teal-550": "oklch(33.77% .0548 217.68deg)",
  "color-teal-500": "oklch(40.6% .0677 216.83deg)",
  "color-teal-450": "oklch(48.03% .0813 214.59deg)",
  "color-teal-400": "oklch(55.87% .0933 207.35deg)",
  "color-teal-350": "oklch(62.69% .1022 202.5deg)",
  "color-teal-300": "oklch(71.25% .1 200.16deg)",
  "color-teal-250": "oklch(80.96% .0919 199.89deg)",
  "color-teal-200": "oklch(85.77% .0718 200.32deg)",
  "color-teal-150": "oklch(90.69% .0406 200.29deg)",
  "color-teal-100": "oklch(95.79% .018 201.11deg)",
  "color-green-500": "oklch(30.72% .0555 158.67deg)",
  "color-green-450": "oklch(37.76% .0714 158.21deg)",
  "color-green-400": "oklch(44.49% .0863 157.92deg)",
  "color-green-350": "oklch(54.72% .1208 156.09deg)",
  "color-green-300": "oklch(64.59% .1519 154.89deg)",
  "color-green-250": "oklch(72.81% .1208 158.17deg)",
  "color-green-200": "oklch(81.01% .0873 162.22deg)",
  "color-green-150": "oklch(89.13% .0532 165.8deg)",
  "color-green-100": "oklch(97.23% .0176 170.1deg)",
  "color-purple-600": "oklch(20.56% .0907 288.24deg)",
  "color-purple-550": "oklch(28.29% .1348 286.02deg)",
  "color-purple-500": "oklch(35.86% .1795 284.97deg)",
  "color-purple-450": "oklch(43.47% .2239 285.34deg)",
  "color-purple-400": "oklch(48.41% .2342 293.93deg)",
  "color-purple-350": "oklch(53.33% .2476 301.09deg)",
  "color-purple-300": "oklch(58.44% .2596 306.65deg)",
  "color-purple-250": "oklch(67.76% .2011 301.5deg)",
  "color-purple-200": "oklch(76.95% .1342 296.84deg)",
  "color-purple-150": "oklch(86.3% .0733 291.71deg)",
  "color-purple-100": "oklch(95.91% .0215 294.6deg)",
  "color-white": "oklch(100% 0 0deg)",
  "color-knockout": "oklch(100% 0 0deg)",
  "color-indigo-500": "#180a3d",
  "color-indigo-400": "#371783",
  "color-indigo-300": "#5022c3",
  "color-indigo-200": "#c0c4fc",
  "color-indigo-100": "#eeeffc",
  "color-blue-500": "#180a3d",
  "color-blue-450": "#281160",
  "color-blue-400": "#371783",
  "color-blue-350": "#431ca3",
  "color-blue-300": "#5022c3",
  "color-blue-250": "#8072e6",
  "color-blue-200": "#c0c4fc",
  "color-blue-150": "#d8e0fb",
  "color-blue-100": "#eeeffc",
  "color-yellow-500": "#223509",
  "color-yellow-450": "#5c6a12",
  "color-yellow-400": "#959b19",
  "color-yellow-350": "#d2cf1e",
  "color-yellow-300": "#e9e729",
  "color-yellow-250": "#eeec5d",
  "color-yellow-200": "#eceb98",
  "color-yellow-150": "#f3f2b8",
  "color-yellow-100": "#f9f9d7",
  "color-icon-neutral": "oklch(29.74% .0362 281.74deg)",
  "color-icon-knockout": "oklch(100% 0 0deg)",
  "color-icon-positive": "oklch(44.49% .0863 157.92deg)",
  "color-icon-negative": "oklch(55.73% .2161 29.71deg)",
  "color-icon-info": "oklch(48.41% .2342 293.93deg)",
  "color-icon-warning": "oklch(62.76% .1418 61.45deg)",
  "color-icon-subdued": "oklch(48.09% .0371 279.08deg)",
  "color-icon-star": "oklch(62.76% .1418 61.45deg)",
  "color-text-default": "oklch(29.74% .0362 281.74deg)",
  "color-text-subdued": "oklch(48.09% .0371 279.08deg)",
  "color-text-white": "oklch(100% 0 0deg)",
  "color-text-knockout": "oklch(100% 0 0deg)",
  "color-text-link": "oklch(48.41% .2342 293.93deg)",
  "color-text-link-decoration": "oklch(67.76% .2011 301.5deg)",
  "color-text-positive": "oklch(44.49% .0863 157.92deg)",
  "color-text-positive-dark": "oklch(30.72% .0555 158.67deg)",
  "color-text-negative": "oklch(55.73% .2161 29.71deg)",
  "color-text-negative-dark": "oklch(42.24% .1681 30.2666deg)",
  "color-text-warning": "oklch(62.76% .1418 61.45deg)",
  "color-text-warning-dark": "oklch(46.68% .1161 51.53deg)",
  "color-text-info": "oklch(29.74% .0362 281.74deg)",
  "color-text-star-rating": "oklch(46.68% .1161 51.53deg)",
  "color-text-default-inverted": "oklch(100% 0 0deg)",
  "color-text-link-inverted": "#c0c4fc",
  "color-text-subdued-inverted": "oklch(86.72% .0192 282.72deg)",
  "color-icon-subdued-inverted": "oklch(79.05% .0283 281.19deg)",
  "color-icon-star-inverted": "oklch(76.62% .166 68.76deg)",
  "font-size-5xl": "clamp(4.2rem, calc(4.2rem + (7.2 - 4.2) * calc((100vw - 36rem) / (144 - 36))), 7.2rem)",
  "font-size-4xl": "clamp(3.6rem, calc(3.6rem + (5.6 - 3.6) * calc((100vw - 36rem) / (144 - 36))), 5.6rem)",
  "font-size-xxxl": "clamp(3.2rem, calc(3.2rem + (4.8 - 3.2) * calc((100vw - 36rem) / (144 - 36))), 4.8rem)",
  "font-size-xxl": "clamp(2.4rem, calc(2.4rem + (3.2 - 2.4) * calc((100vw - 36rem) / (144 - 36))), 3.2rem)",
  "font-size-xl": "clamp(2rem, calc(2rem + (2.4 - 2) * calc((100vw - 36rem) / (144 - 36))), 2.4rem)",
  "font-size-lg": "clamp(1.7rem, calc(1.7rem + (1.8 - 1.7) * calc((100vw - 36rem) / (144 - 36))), 1.8rem)",
  "font-size-md": "1.6rem",
  "font-size-sm": "1.4rem",
  "font-size-xs": "1.2rem",
  "font-size-xxs": "1rem",
  "font-stack-mono": "'SFMono-Regular',Consolas,'Liberation Mono',Menlo,Courier,monospace",
  "font-stack-heading": "'Udemy Sans','Noto Sans JP','Vazirmatn',-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
  "font-stack-heading-serif": "'Udemy Sans','Noto Sans JP','Vazirmatn',-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
  "font-stack-text": "'Udemy Sans','Noto Sans JP','Vazirmatn','SF Pro Text',-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
  "font-stack-heading-vi-vn": "Arial,-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
  "font-stack-heading-serif-vi-vn": "Arial,-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
  "font-stack-text-vi-vn": "Arial,-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI',Helvetica,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
  "space-xxs": ".4rem",
  "space-xs": ".8rem",
  "space-xs-mid": "1.2rem",
  "space-sm": "1.6rem",
  "space-md": "2.4rem",
  "space-lg": "3.2rem",
  "space-xl": "4.8rem",
  "space-xxl": "6.4rem",
  "space-xxxl": "9.6rem",
  "space-4xl": "14.4rem",
  "layout-ud-container-padding": "2.4rem",
  "space-section": "4.8rem",
  "space-section-lg": "6.4rem",
  "animation-duration-extrafast": "100ms",
  "animation-duration-fast": "150ms",
  "animation-duration-moderate": "250ms",
  "animation-duration-slow": "400ms",
  "breakpoint-to-length": "1.6rem",
  "viewport-xxl-min": "83.8125rem",
  "viewport-xl-max": "83.75rem",
  "viewport-xl-min": "75.0625rem",
  "viewport-lg-max": "75rem",
  "viewport-lg-min": "61.3125rem",
  "viewport-md-max": "61.25rem",
  "viewport-md-min": "43.8125rem",
  "viewport-sm-max": "43.75rem",
  "viewport-sm-min": "37.5625rem",
  "viewport-xs-max": "37.5rem",
  "viewport-xs-min": "23.5rem",
  "viewport-xxs-max": "23.4375rem",
  "viewport-xxs-min": "20rem",
  "viewport-xxxs-max": "19.9375rem",
  "breakpoint-header-mobile-max": "50rem",
  "breakpoint-header-desktop-min": "50.0625rem",
  "breakpoint-xxl-min": "83.8125rem",
  "breakpoint-xl-max": "83.75rem",
  "breakpoint-xl-min": "75.0625rem",
  "breakpoint-lg-max": "75rem",
  "breakpoint-lg-min": "61.3125rem",
  "breakpoint-md-max": "61.25rem",
  "breakpoint-md-min": "43.8125rem",
  "breakpoint-sm-max": "43.75rem",
  "breakpoint-sm-min": "37.5625rem",
  "breakpoint-mobile-max": "37.5rem",
  "breakpoint-mobile-min": "23.5rem",
  "breakpoint-mobile-xs-max": "23.4375rem",
  "breakpoint-mobile-xs-min": "20rem",
  "breakpoint-mobile-xxs-max": "19.9375rem",
  "layout-12-column-page-gutter": "1.6rem",
  "layout-12-column-page-12-columns-min": "43.8125rem",
  "layout-12-column-page-4-columns-max": "43.75rem"
};
//# sourceMappingURL=index.js.map